export { default as homeVideo } from './home_video.mp4'
export { default as new_logo } from './new_logo.svg'
export { default as values_card_1 } from './values_card_1.png'
export { default as values_card_2 } from './values_card_2.png'
export { default as values_card_3 } from './values_card_3.png'
export { default as values_card_4 } from './values_card_4.png'
export { default as values_card_5 } from './values_card_5.png'
export { default as login_img } from './login_img.png'
export { default as banner_traveller } from './banner-we-are-travelers.jpg'
export { default as about_roots } from './web-about-us-our-roots.jpg'
export { default as about_togather } from './web-about-us-together.jpg'
export { default as about_traveller } from './web-about-us-born-from-travelers.jpg'
export { default as square_values_sustainability } from './square-values-sustainability.jpg'
export { default as square_values_growth } from './square-values-growth.jpg'
export { default as square_values_freedom } from './square-values-freedom.jpg'
export { default as square_values_community } from './square-values-community.jpg'
export { default as square_values_knowledge } from './square-values-knowledge.jpg'
export { default as banner_packing_match } from './banner-packing-match.jpg'
export { default as banner_packing_filter } from './banner-packing-filters.jpg'
export { default as primary_badge } from './primary_badge.png'
export { default as premium_badge } from './premium-badge.png'